import script from "./ModalPost.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalPost.vue?vue&type=script&setup=true&lang=ts"

import "./ModalPost.vue?vue&type=style&index=0&id=49ee7212&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49ee7212"]])

export default __exports__